import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/no-image.png'
import _imports_1 from '@/assets/img/coin-icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-5fed7678")

_pushScopeId("data-v-5fed7678")
const _hoisted_1 = { class: "talent-info" }
const _hoisted_2 = { class: "talent-info-card" }
const _hoisted_3 = { class: "talent-info-card-container" }
const _hoisted_4 = { class: "talent-info-card-container-left" }
const _hoisted_5 = {
  key: 0,
  class: "talent-info-image",
  src: _imports_0
}
const _hoisted_6 = { class: "talent-info-button" }
const _hoisted_7 = { class: "talent-info-button-deeplink-container" }
const _hoisted_8 = { class: "talent-info-button-deeplink" }
const _hoisted_9 = { class: "talent-info-button-deeplink" }
const _hoisted_10 = { class: "talent-info-box" }
const _hoisted_11 = { class: "talent-name-container" }
const _hoisted_12 = { class: "talent-name-box" }
const _hoisted_13 = { class: "talent-name txt txt-headline" }
const _hoisted_14 = {
  key: 0,
  class: "live-onair"
}
const _hoisted_15 = { class: "talent-live" }
const _hoisted_16 = /*#__PURE__*/_createVNode("h3", { class: "talent-live-info txt txt-small" }, "開催中", -1)
const _hoisted_17 = { class: "talent-info-slide" }
const _hoisted_18 = { class: "talent-info-slide-headline-box" }
const _hoisted_19 = { class: "talent-info-slide-headline-box" }
const _hoisted_20 = {
  key: 0,
  class: "talent-info-slide-message txt txt-medium"
}
const _hoisted_21 = {
  key: 1,
  class: "talent-info-slide-schedule"
}
const _hoisted_22 = { class: "schedule-title txt txt-small" }
const _hoisted_23 = { class: "schedule-container" }
const _hoisted_24 = { class: "schedule-meta" }
const _hoisted_25 = { class: "schedule-date txt txt-medium" }
const _hoisted_26 = { class: "schedule-capacity txt txt-small" }
const _hoisted_27 = { class: "reservation-dialog-content" }
const _hoisted_28 = /*#__PURE__*/_createVNode("p", { class: "txt txt-medium" }, "通話を予約しよう！", -1)
const _hoisted_29 = { class: "reservation-dialog-user" }
const _hoisted_30 = { class: "txt txt-medium" }
const _hoisted_31 = { class: "txt txt-small" }
const _hoisted_32 = { class: "reservation-dialog-user" }
const _hoisted_33 = { class: "txt txt-medium" }
const _hoisted_34 = { class: "txt txt-small" }
const _hoisted_35 = { class: "txt txt-medium reservation-dialog-note" }
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "reservation-dialog-note-title" }, "1通話の価格", -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("img", {
  class: "coins-icon",
  src: _imports_1
}, null, -1)
const _hoisted_38 = { class: "txt txt-medium reservation-dialog-note" }
const _hoisted_39 = /*#__PURE__*/_createVNode("span", { class: "reservation-dialog-note-title" }, "所持コイン", -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("img", {
  class: "coins-icon",
  src: _imports_1
}, null, -1)
const _hoisted_41 = { class: "txt txt-medium reservation-dialog-note" }
const _hoisted_42 = /*#__PURE__*/_createVNode("span", { class: "reservation-dialog-note-title" }, "オンリーフォト価格", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("img", {
  class: "coins-icon",
  src: _imports_1
}, null, -1)
const _hoisted_44 = {
  class: "app-open-guide-content",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "app-open-guide-title"
}
const _hoisted_45 = /*#__PURE__*/_createVNode("h2", {
  class: "app-open-guide-title",
  id: "app-open-guide-title"
}, "onlyliveアプリで予約できます", -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("p", { class: "app-open-guide-description" }, "アプリが開かない場合は、リンクをコピーしてSafariやChromeなどのブラウザで開いてください。", -1)
const _hoisted_47 = { class: "app-open-guide-link-field" }
const _hoisted_48 = /*#__PURE__*/_createVNode("label", {
  class: "app-open-guide-link-label",
  for: "app-open-guide-link"
}, "共有リンク", -1)
const _hoisted_49 = { class: "app-open-guide-actions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Loading = _resolveComponent("Loading")
  const _component_Imgix = _resolveComponent("Imgix")
  const _component_BaseRoundRectButton = _resolveComponent("BaseRoundRectButton")
  const _component_AppDownloadModal = _resolveComponent("AppDownloadModal")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_SignInModal = _resolveComponent("SignInModal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Loading, { isActive: _ctx.isLoading }, null, 8, ["isActive"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          (_ctx.talent.mainImage === '')
            ? (_openBlock(), _createBlock("img", _hoisted_5))
            : (_openBlock(), _createBlock(_component_Imgix, {
                key: 1,
                class: "talent-info-image",
                imageUrl: _ctx.talent.mainImage,
                imageSize: _ctx.imageSize
              }, null, 8, ["imageUrl", "imageSize"])),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_BaseRoundRectButton, {
              class: "btn notice-button",
              text: "アプリをダウンロード",
              onClick: _ctx.openModal
            }, null, 8, ["onClick"])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("a", {
                class: "deeplink",
                href: _ctx.iosDeeplink
              }, [
                _createVNode(_component_BaseRoundRectButton, {
                  class: "btn notice-button",
                  text: "IOSアプリをダウンロード",
                  onClick: _ctx.openIOSdeeplink
                }, null, 8, ["onClick"])
              ], 8, ["href"])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("a", {
                class: "deeplink",
                href: _ctx.androidDeeplink
              }, [
                _createVNode(_component_BaseRoundRectButton, {
                  class: "btn notice-button",
                  text: "Androidアプリをダウンロード",
                  onClick: _ctx.openAndroiddeeplink
                }, null, 8, ["onClick"])
              ], 8, ["href"])
            ])
          ]),
          (_ctx.state.isOpenModal)
            ? (_openBlock(), _createBlock(_component_AppDownloadModal, {
                key: 2,
                imageSrc: _ctx.talent.mainImage,
                onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.isOpenModal = false))
              }, null, 8, ["imageSrc"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, _toDisplayString(_ctx.talent.displayName), 1),
              (_ctx.nowFanMeeting !== undefined)
                ? (_openBlock(), _createBlock("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "live-icon",
                        icon: "phone"
                      })
                    ]),
                    _hoisted_16
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, [
              (_ctx.state.isActive)
                ? (_openBlock(), _createBlock("p", {
                    key: 0,
                    class: "talent-info-slide-headline-active txt txt-medium",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.active_schedule && _ctx.active_schedule(...args)))
                  }, "次回以降のスケジュール"))
                : _createCommentVNode("", true),
              (!_ctx.state.isActive)
                ? (_openBlock(), _createBlock("p", {
                    key: 1,
                    class: "talent-info-slide-headline-notActive txt txt-medium",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.active_schedule && _ctx.active_schedule(...args)))
                  }, "次回以降のスケジュール"))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_19, [
              (!_ctx.state.isActive)
                ? (_openBlock(), _createBlock("p", {
                    key: 0,
                    class: "talent-info-slide-headline-active txt txt-medium",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.active_intro && _ctx.active_intro(...args)))
                  }, "自己紹介"))
                : _createCommentVNode("", true),
              (_ctx.state.isActive)
                ? (_openBlock(), _createBlock("p", {
                    key: 1,
                    class: "talent-info-slide-headline-notActive txt txt-medium",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.active_intro && _ctx.active_intro(...args)))
                  }, "自己紹介"))
                : _createCommentVNode("", true)
            ])
          ]),
          (!_ctx.state.isActive)
            ? (_openBlock(), _createBlock("div", _hoisted_20, _toDisplayString(_ctx.talent.introduction), 1))
            : _createCommentVNode("", true),
          (_ctx.state.isActive)
            ? (_openBlock(), _createBlock("div", _hoisted_21, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.schedule, (s) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "schedule",
                    key: s.fanMeeting.id
                  }, [
                    _createVNode("p", _hoisted_22, _toDisplayString(s.fanMeeting.title), 1),
                    _createVNode("div", _hoisted_23, [
                      _createVNode("div", _hoisted_24, [
                        _createVNode("span", _hoisted_25, _toDisplayString(s.fanMeeting.convertUnixToDate), 1),
                        _createVNode("span", _hoisted_26, _toDisplayString(s.fanMeeting.limitedPeople) + "人限定", 1)
                      ]),
                      (s.reservationSummaryState.isSoldOut === true)
                        ? (_openBlock(), _createBlock(_component_BaseRoundRectButton, {
                            key: 0,
                            class: "btn schedule-button",
                            text: "売り切れ",
                            disable: true
                          }))
                        : _createCommentVNode("", true),
                      (s.reservationSummaryState.isSoldOut === false)
                        ? (_openBlock(), _createBlock(_component_BaseRoundRectButton, {
                            key: 1,
                            class: "btn schedule-button",
                            text: s.isReserved ? '予約済み' : '予約する',
                            disable: s.isReserved,
                            onClick: ($event: any) => (_ctx.openReservationDialog(s))
                          }, null, 8, ["text", "disable", "onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.state.isOpenReservationModal)
        ? (_openBlock(), _createBlock(_component_Dialog, {
            key: 0,
            class: "reservation-dialog"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_27, [
                _createVNode(_component_font_awesome_icon, {
                  class: "window-close-icon",
                  icon: "window-close",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.isOpenReservationModal = false))
                }),
                _hoisted_28,
                _createVNode("div", _hoisted_29, [
                  _createVNode("div", {
                    class: "image",
                    style: _ctx.selectedFanMeeting?.fanMeeting.streamerLiveStreamMethodType === _ctx.LiveStreamMethodType.video ? { backgroundColor: '#a3b7ff' } : { backgroundColor: '#A1AAB8' }
                  }, [
                    _createVNode(_component_Imgix, {
                      imageUrl: _ctx.talent.mainImage,
                      imageSize: _ctx.iconImageSize
                    }, null, 8, ["imageUrl", "imageSize"]),
                    (_ctx.selectedFanMeeting?.fanMeeting.streamerLiveStreamMethodType === _ctx.LiveStreamMethodType.video)
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 0,
                          class: "icon video",
                          icon: "video"
                        }))
                      : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 1,
                          class: "icon video-slash",
                          icon: "video-slash"
                        }))
                  ], 4),
                  _createVNode("p", _hoisted_30, _toDisplayString(_ctx.talent.displayName), 1),
                  _createVNode("p", _hoisted_31, _toDisplayString(_ctx.selectedFanMeeting?.fanMeeting.streamerLiveStreamMethodType === _ctx.LiveStreamMethodType.video ? "動画配信" : "画像配信") + " " + _toDisplayString(_ctx.selectedFanMeeting?.fanMeeting.isExtension ? "(延長あり)" : ""), 1)
                ]),
                _createVNode(_component_font_awesome_icon, { icon: "ellipsis-v" }),
                _createVNode("div", _hoisted_32, [
                  _createVNode("div", {
                    class: "image",
                    style: _ctx.selectedFanMeeting?.fanMeeting.viewerLiveStreamMethodType === _ctx.LiveStreamMethodType.video ? { backgroundColor: '#a3b7ff' } : { backgroundColor: '#A1AAB8' }
                  }, [
                    _createVNode(_component_Imgix, {
                      imageUrl: _ctx.fan?.image_uri,
                      imageSize: _ctx.iconImageSize
                    }, null, 8, ["imageUrl", "imageSize"]),
                    (_ctx.selectedFanMeeting?.fanMeeting.viewerLiveStreamMethodType === _ctx.LiveStreamMethodType.video)
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 0,
                          class: "icon video",
                          icon: "video"
                        }))
                      : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 1,
                          class: "icon video-slash",
                          icon: "video-slash"
                        }))
                  ], 4),
                  _createVNode("p", _hoisted_33, _toDisplayString(_ctx.fan?.display_name), 1),
                  _createVNode("p", _hoisted_34, _toDisplayString(_ctx.selectedFanMeeting?.fanMeeting.viewerLiveStreamMethodType === _ctx.LiveStreamMethodType.video ? "顔出しあり" : "顔出しなし"), 1)
                ]),
                _createVNode("p", _hoisted_35, [
                  _hoisted_36,
                  _hoisted_37,
                  _createVNode("span", null, _toDisplayString(_ctx.coinNum) + " / " + _toDisplayString(_ctx.displayTime(_ctx.selectedFanMeeting?.fanMeeting.secondsPerReservation ?? 0)), 1)
                ]),
                _createVNode("p", _hoisted_38, [
                  _hoisted_39,
                  _hoisted_40,
                  _createVNode("span", null, _toDisplayString(_ctx.balance), 1)
                ]),
                _createVNode("p", _hoisted_41, [
                  _hoisted_42,
                  _hoisted_43,
                  _createVNode("span", null, _toDisplayString(_ctx.selectedFanMeeting?.fanMeeting.chekiPrice === 0 ? "無料" : _ctx.selectedFanMeeting?.fanMeeting.chekiPrice), 1)
                ]),
                _createVNode(_component_BaseRoundRectButton, {
                  class: "btn",
                  text: _ctx.reserveText(_ctx.selectedFanMeeting),
                  onClick: _ctx.createReservation
                }, null, 8, ["text", "onClick"]),
                _createVNode("a", {
                  class: "coin-purchase-button",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.pushShop && _ctx.pushShop(...args)))
                }, "コイン購入")
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.nowFanMeeting != undefined)
        ? (_openBlock(), _createBlock(_component_BaseRoundRectButton, {
            key: 1,
            class: "btn create-now-reservation-button",
            text: _ctx.nowFanMeeting.isReserved ? '予約済み' : '予約する',
            disable: _ctx.nowFanMeeting.isReserved,
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openReservationDialog(_ctx.nowFanMeeting)))
          }, null, 8, ["text", "disable"]))
        : _createCommentVNode("", true),
      (_ctx.state.isOpenAppOpenGuideModal)
        ? (_openBlock(), _createBlock("div", {
            key: 2,
            class: "app-open-guide",
            onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeAppOpenGuide && _ctx.closeAppOpenGuide(...args)), ["self"]))
          }, [
            _createVNode("div", _hoisted_44, [
              _createVNode("button", {
                class: "app-open-guide-close",
                type: "button",
                "aria-label": "ダイアログを閉じる",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeAppOpenGuide && _ctx.closeAppOpenGuide(...args)))
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "times" })
              ]),
              _hoisted_45,
              _hoisted_46,
              _createVNode("div", _hoisted_47, [
                _hoisted_48,
                _createVNode("input", {
                  class: "app-open-guide-link",
                  id: "app-open-guide-link",
                  value: _ctx.appLink,
                  readonly: ""
                }, null, 8, ["value"])
              ]),
              _createVNode("div", _hoisted_49, [
                _createVNode(_component_BaseRoundRectButton, {
                  class: "btn open-app-button",
                  text: "アプリを開く",
                  onClick: _ctx.openAppDeepLink
                }, null, 8, ["onClick"]),
                _createVNode(_component_BaseRoundRectButton, {
                  class: "btn copy-link-button",
                  text: _ctx.copyLinkText,
                  onClick: _ctx.copyAppLink
                }, null, 8, ["text", "onClick"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.state.isOpenSignInModal)
      ? (_openBlock(), _createBlock(_component_SignInModal, {
          key: 0,
          onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.isOpenSignInModal = false))
        }))
      : _createCommentVNode("", true)
  ]))
})